import { render, staticRenderFns } from "./RelationList.vue?vue&type=template&id=8490a3d0&scoped=true&"
import script from "./RelationList.vue?vue&type=script&lang=js&"
export * from "./RelationList.vue?vue&type=script&lang=js&"
import style0 from "./RelationList.vue?vue&type=style&index=0&id=8490a3d0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8490a3d0",
  null
  
)

export default component.exports